import { useEffect, useState } from 'react';
import { DoqFace } from './DoqFace';
import { DoqSize, DoqType } from './types';

export type DoqLoadingAnimationProps = {
  delay?: number;
  doqs: DoqType[];
  doqSize?: DoqSize;
};

export const DoqLoadingAnimation = ({
  delay = 333,
  doqs,
  doqSize = DoqSize.SMALL,
}: DoqLoadingAnimationProps) => {
  const [index, setIndex] = useState(Math.floor(Math.random() * doqs.length));
  useEffect(() => {
    const timeout = setTimeout(
      () => setIndex((index + 1) % doqs.length),
      delay
    );

    return () => clearTimeout(timeout);
  });
  return <DoqFace doqType={doqs[index]} doqSize={doqSize} />;
};
